import type { FeatureContext } from '../../types';
import { formatDate } from '../../shared/formatters';

import './connectivity.css';

export function ConnectivityFeature({ connectionTest }: FeatureContext) {
  return (
    <section className="page-section connectivity">
      <h2>Connection Test</h2>
      {connectionTest ? (
        <div className="connectivity__status" role="status" aria-live="polite">
          <p className="connectivity__message">
            <span className="connectivity__indicator" aria-hidden="true">
              {connectionTest.ok ? '✅' : '⚠️'}
            </span>
            {connectionTest.message}
          </p>
          <p className="connectivity__timestamp">
            <small>Last checked {formatDate(connectionTest.timestamp)}</small>
          </p>
        </div>
      ) : (
        <p className="connectivity__placeholder">
          Connectivity checks will appear here after the backend responds.
        </p>
      )}
    </section>
  );
}
